module.exports = __webpack_public_path__ + "static/team_img1-248402fcfb07ffc749b510ea9e7fc215.png";